import { styled } from '@mui/material';

const PREFIX = 'TermsAgreed';

export const termsAgreedClasses = {
  termsAgreed: `${PREFIX}-termsAgreed`,
  termsAgreedLinks: `${PREFIX}-termsAgreedLinks`,
};

export const TermsAgreedRoot = styled('p')(() => ({
  [`&.${termsAgreedClasses.termsAgreed}`]: {
    fontSize: '0.875rem',
    cursor: 'default',
  },

  [`& .${termsAgreedClasses.termsAgreedLinks}`]: {
    marginLeft: '0.2rem',
  },
}));